module.exports = __webpack_public_path__ + "img/case1.8b0b856a.png";